import { Component, Input } from '@angular/core';

export interface BreadcrumbItem {
    label: string;
    path?: string;
    action?: () => void;
    skipTranslate?: boolean;
}

@Component({
    selector: 'lokos-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss',
    standalone: false,
})
export class BreadcrumbComponent {
    @Input() items: BreadcrumbItem[] = [];
}
